<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Editar Perfil</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i><div class="content">Editar Perfil</div></h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/dashboard')">
    <i class="close icon"></i>Cerrar
  </button>
  <div v-if="!selectedUser" class="ui active centered inline loader"></div>
  <div v-if="selectedUser" class="ui center aligned padding grid">

    <div class="row">
      <div class="ui small card">
        <div class="image">
      <img class="ui mini image" src="../../assets/user.png">
    </div>
        <div class="content">
          <div class="header" >{{selectedUser.name}}</div>
          <div class="meta">
            {{selectedUser.username}}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <form class="ui form" @submit.prevent="editUser">
        <h4 class="ui dividing header">Editar Información</h4>
        <div class="field">
          <label>Nombre y Apellido *</label>
          <input type="text" v-model="selectedUser.name" placeholder="Nombre y Apellido" required>
          </div>
        <div class="two fields">
          <div class="field">
            <label>Username *</label>
            <input type="text" v-model="selectedUser.username" placeholder="Username" required>
            </div>
          <div class="field">
            <label>Password *</label>
            <!--<input type="text" v-model="selectedUser.password" placeholder="Password" required>-->
            <input type="password" v-model="selectedUser.password" placeholder="Password" required>
            </div>
        </div>
        <div class="field">
          <label>Email *</label>
          <input type="text" v-model="selectedUser.email" placeholder="Email" required>
        </div>        
        <div class="field">
          <label>Imagen para el Avatar</label>
          <input type="file" accept="image/*" @change="onFilePicked">
          </div>
        <button class="ui button" type="submit">Guardar</button>
        <div class="ui red button eskubian" v-on:click="goTo('/dashboard')">Cancelar</div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'profileEdit',
  data() {
    return {
      selectedUser: null,
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      hapiickApi().post('/v2/users/get-user', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => this.updateEditUser(request))
      .catch(() => console.log('error getting user'))
    },
    editUser() {
      hapiickApi().post('/v2/users/edit-profile', {
        admin_id: JSON.parse(localStorage.admin).id,
        userData: this.selectedUser,
      })
      .then(request => this.userSaved(request))
      .catch(() => this.$swal({
        type: 'error',
        title: 'Error',
        text: 'No se han podido guardar los datos'
      }))
    },
    goTo(where) {
      this.$router.push(where)
    },
    updateEditUser(req) {
      let user = JSON.parse(JSON.stringify(req.data.data.user))
      this.selectedUser = user.Administrator
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.selectedUser.image = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    },
    userSaved(req) {
      let msg='';
      if (req.data.status != 'OK') {
        if (req.data.status === 'KO') {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }

        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })
      } else {
        this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.goTo('/users/profile')
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/profileEdit.vue